import React, { PropsWithChildren, useCallback, useContext, useEffect, useState } from 'react';
import { Cell } from '@ff-os/shared-react/components/grid/Cell';
import { Grid } from '@ff-os/shared-react/components/grid/Grid';
import { ScrollContainer } from '@ff-os/shared-react/components/scroll-container/ScrollContainer';
import { WindowBody } from '@ff-os/shared-react/components/window/partials/WindowBody';
import classNames from 'classnames';
import { Orientation } from '../../../context/Orientation';
import { PreviewSize } from '../../../context/PreviewSize';
import { GiftWindowPreviewUi } from './GiftWindowPreviewUi';
import styles from './GiftWindowBody.module.scss';

export const GiftWindowBody = ({ children }: Props) => {

    const { previewSize } = useContext(PreviewSize);
    const { orientation } = useContext(Orientation);
    const [isFullscreen, setFullscreen] = useState(false);

    const isContentFirst = previewSize === 'hidden' && orientation === 'landscape';

    const containerClassNames = classNames(styles.container, styles[previewSize], styles[orientation], {
        [styles.fullscreen]: isFullscreen
    });

    useEffect(() => {
        setFullscreen(false);
    }, [previewSize]);

    const toggleFullscreen = useCallback(() => {
        setFullscreen(!isFullscreen);
    }, [isFullscreen]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className={containerClassNames}>
            <Grid className={styles.grid} gap='s' fullHeight fullWidth>
                <Cell className={styles.cell}>
                    <div className={styles.backdrop}>
                        <GiftWindowPreviewUi
                            isFullscreen={isFullscreen}
                            toggleFullscreen={toggleFullscreen} />
                    </div>
                </Cell>

                <Cell className={styles.cell}>
                    <WindowBody className={styles.body} disableScroll={isContentFirst}>
                        <div className={styles.content}>
                            {isContentFirst ? (
                                children
                            ) : (
                                <ScrollContainer maxHeight='100%'>
                                    {children}
                                </ScrollContainer>
                            )}
                        </div>
                    </WindowBody>
                </Cell>
            </Grid>
        </div>
    );
};

type Props = PropsWithChildren<Record<never, never>>;